<template>
  <b-row class="mt-1">

    <!-- Field: Address Line 1 -->
    <b-col
      cols="12"
    >
      <b-form-group
        label="CEP"
        label-for="postcode"
      >
        <validation-provider
          #default="{ errors }"
          name="CEP"
          rules="required"
        >
          <b-form-input
            id="postcode"
            v-model="address.zip_code"
            v-mask="'#####-###'"
            :state="errors.length > 0 ? false:null"
            name="postcode"
            placeholder="Ex.: 12345-678"
            @input="buscarViaCep($event)"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col>

    <!-- Field: Address Line 2 -->
    <b-col
      cols="12"
      md="8"
    >
      <b-form-group
        label="Endereço"
        label-for="address-line-2"
      >
        <validation-provider
          #default="{ errors }"
          name="Endereço"
          rules="required"
        >
          <b-form-input
            id="address-line-2"
            v-model="address.rua"
            :state="errors.length > 0 ? false:null"
            placeholder="Ex. Rua dos Três Irmãos"
            :disabled="disabledInput('rua')"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col>

    <!-- Field: Postcode -->
    <b-col
      cols="12"
      md="4"
    >
      <b-form-group
        label="Número"
        label-for="address-line-1"
      >
        <validation-provider
          #default="{ errors }"
          name="Número"
          rules="required"
        >
          <b-form-input
            id="address-line-1"
            v-model="address.numero"
            :state="errors.length > 0 ? false:null"
            name="address-line-1"
            type="number"
            placeholder="597"
            :disabled="disabledInput('numero')"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>

    </b-col>

    <!-- Field: City -->
    <b-col
      cols="12"
      md="12"
    >
      <b-form-group
        label="Complemento"
        label-for="country"
      >
        <validation-provider
          #default="{ errors }"
          name="Complemento"
          rules="required"
        >
          <b-form-input
            id="address-line-1"
            v-model="address.complemento"
            :state="errors.length > 0 ? false:null"
            name="address-line-1"
            placeholder="Ex. Apto 12"
            :disabled="disabledInput('complemento')"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col>

    <!-- Field: City -->
    <b-col
      cols="12"
      md="4"
    >
      <b-form-group
        label="Bairro"
        label-for="country"
      >
        <validation-provider
          #default="{ errors }"
          name="Bairro"
          rules="required"
        >
          <b-form-input
            id="address-line-1"
            v-model="address.bairro"
            :state="errors.length > 0 ? false:null"
            name="address-line-1"
            placeholder="Ex. Vila Mariana"
            :disabled="disabledInput('bairro')"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col>

    <!-- Field: State -->
    <b-col
      cols="12"
      md="4"
    >
      <b-form-group
        label="Cidade"
        label-for="city"
      >
        <validation-provider
          #default="{ errors }"
          name="Cidade"
          rules="required"
        >
          <b-form-input
            id="city"
            v-model="address.cidade"
            :state="errors.length > 0 ? false:null"
            placeholder="Ex. São Paulo"
            :disabled="disabledInput('cidade')"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col>

    <!-- Field: Country -->
    <b-col
      cols="12"
      md="4"
    >
      <b-form-group
        label="Estado"
        label-for="state"
      >
        <validation-provider
          #default="{ errors }"
          name="Estado"
          rules="required"
        >
          <b-form-select
            v-model="address.estado"
            :options="optionsState"
            :state="errors.length > 0 ? false:null"
            :disabled="disabledInput('estado')"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import {
  BFormInput, BFormGroup, BRow, BCol,
} from 'bootstrap-vue'
import { required, email } from '@validations'

export default {
  name: 'AddressBilling',
  components: {
    ValidationProvider,
    BFormInput,
    BFormGroup,
    BRow,
    BCol,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        zip_code: '',
        rua: '',
        numero: '',
        complemento: '',
        bairro: '',
        cidade: '',
        estado: '',
      }),
    },
  },
  data() {
    return {
      disabledInputArra: [],
      required,
      email,
      optionsState: [
        { value: 'AC', text: 'Acre' },
        { value: 'AL', text: 'Alagoas' },
        { value: 'AP', text: 'Amapá' },
        { value: 'AM', text: 'Amazonas' },
        { value: 'BA', text: 'Bahia' },
        { value: 'CE', text: 'Ceará' },
        { value: 'DF', text: 'Distrito Federal' },
        { value: 'ES', text: 'Espírito Santo' },
        { value: 'GO', text: 'Goiás' },
        { value: 'MA', text: 'Maranhão' },
        { value: 'MT', text: 'Mato Grosso' },
        { value: 'MS', text: 'Mato Grosso do Sul' },
        { value: 'MG', text: 'Minas Gerais' },
        { value: 'PA', text: 'Pará' },
        { value: 'PB', text: 'Paraíba' },
        { value: 'PR', text: 'Paraná' },
        { value: 'PE', text: 'Pernambuco' },
        { value: 'PI', text: 'Piauí' },
        { value: 'RJ', text: 'Rio de Janeiro' },
        { value: 'RN', text: 'Rio Grande do Norte' },
        { value: 'RS', text: 'Rio Grande do Sul' },
        { value: 'RO', text: 'Rondônia' },
        { value: 'RR', text: 'Roraima' },
        { value: 'SC', text: 'Santa Catarina' },
        { value: 'SP', text: 'São Paulo' },
        { value: 'SE', text: 'Sergipe' },
        { value: 'TO', text: 'Tocantins' },
      ],
    }
  },
  computed: {
    address: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {
    disabledInput(name) {
      return Object.keys(this.address).includes(name) && this.disabledInputArra.includes(name)
    },
    buscarViaCep(event) {
      if (event.length > 9) return
      const cep = event.replace(/\D/g, '')
      if (cep.length === 8) {
        fetch(`https://viacep.com.br/ws/${cep}/json/`)
          .then(response => response.json())
          .then(data => {
            if (data.logradouro) {
              this.disabledInputArra.push('rua')
            }
            if (data.bairro) {
              this.disabledInputArra.push('bairro')
            }
            if (data.localidade) {
              this.disabledInputArra.push('cidade')
            }
            if (data.uf) {
              this.disabledInputArra.push('estado')
            }
            this.address.rua = data.logradouro
            this.address.bairro = data.bairro
            this.address.cidade = data.localidade
            this.address.estado = data.uf
          })
      }
    },
  },
}

</script>
<style scoped lang="scss">

</style>
